import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import classNames from "classnames"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons"

const DatePicker = ({
  error = "",
  placeholder,
  value = "",
  onChange,
  className = "",
  wrapperClassName = "w-[110px] flex justify-between items-center border rounded-[4px] bg-transparent bg-white",
  ...props
}) => (
  <div>
    <div
      className={classNames(
        wrapperClassName,
        {
          "border-gray-300": !error,
        },
        {
          "border-red-500": error,
        }
      )}
    >
      <ReactDatePicker
        scrollableYearDropdown
        showIcon
        showMonthDropdown
        showYearDropdown
        className={classNames(
          "outline-none border-0 bg-transparent px-1 h-6 text-[12px] no-spinner ml-1",
          className
        )}
        icon={
          <FontAwesomeIcon
            className="!w-[13px] !h-[13px] cursor-pointer -translate-y-[1.2px]"
            icon={faCalendarAlt}
          />
        }
        placeholderText={placeholder}
        // react-datepicker's own popper sits at z-index 1, which loses to any
        // sticky table header or toolbar it opens over. Marked important because
        // that z-index comes from the library stylesheet.
        popperClassName="!z-50"
        selected={value}
        yearDropdownItemNumber={80}
        onChange={onChange}
        {...props}
      />
    </div>
    {error && <p className="text-xs text-red-500 ml-1">{error}</p>}
  </div>
)
export default DatePicker
